 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGHT from '@/components/html/03_Copyright'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML01_SERIES_PAGE from '@/components/html/01_Series_Page'
 import HTML04_CONTENTS from '@/components/html/04_CONTENTS'
 import HTML05_PREFACE from '@/components/html/05_Preface'
 import HTML06_1__PROLOGUE__WHAT_THIS_BOOK_IS_A from '@/components/html/06_1__Prologue__What_This_Book_Is_A'
 import HTML07_2__VECTOR_TYPES_AND_VECTOR_OPERA from '@/components/html/07_2__Vector_Types_and_Vector_Opera'
 import HTML08_3__MORE_OPERATIONS__MORE_VECTORS from '@/components/html/08_3__More_Operations__More_Vectors'
 import HTML09_4__COMPLETION_OF_THE_MENAGERIE from '@/components/html/09_4__Completion_of_the_Menagerie'
 import HTML10_5__FIELDS_AND_THE_GEOMETRICAL_CA from '@/components/html/10_5__Fields_and_the_Geometrical_Ca'
 import HTML11_6__COORDINATES_AND_COMPONENTS from '@/components/html/11_6__Coordinates_and_Components'
 import HTML12_7__THE_GRAND_ALGEBRAIZATION_RULE from '@/components/html/12_7__The_Grand_Algebraization_Rule'
 import HTML13_8__GOODBYE_TO_THE_RUBBER_UNIVERS from '@/components/html/13_8__Goodbye_to_the_Rubber_Univers'
 import HTML14_9__EPILOGUE__WHERE_THIS_BOOK_LEA from '@/components/html/14_9__Epilogue__Where_This_Book_Lea'
 import HTML15_INDEX from '@/components/html/15_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_CONTENTS",
 			"name" : "html/04_CONTENTS",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Preface",
 			"name" : "html/05_Preface",
 			"component" : HTML05_PREFACE
 		},
 		{
 			"path" : "/html/06_1__Prologue__What_This_Book_Is_A",
 			"name" : "html/06_1__Prologue__What_This_Book_Is_A",
 			"component" : HTML06_1__PROLOGUE__WHAT_THIS_BOOK_IS_A
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js